import Cookies from 'js-cookie';

import { consumeExchangeToken, createExchangeToken } from '@libs/api-proxy-client';
import type { IdentityUser } from '@libs/common-next';
import type { IdentityAuthSuccessResponse } from '@libs/common-types';
import { AUTH_COOKIES } from '@libs/core';

export async function requestExTokenVelocity() {
    return await createExchangeToken();
}

export type LoginExToken = {
    exchangeToken?: string;
    user?: IdentityUser;
};

function setAuthCookies(res: IdentityAuthSuccessResponse) {
    const expiryTimestamp = Date.now() + res.expiresIn * 1000;

    Cookies.set(AUTH_COOKIES.ACCESS_TOKEN, res?.accessToken || '', {
        expires: expiryTimestamp,
    });
    Cookies.set(AUTH_COOKIES.REFRESH_TOKEN, res?.refreshToken || '', {});
    Cookies.set(AUTH_COOKIES.LAST_ACTIVE, Date.now().toString(), {});
    // Same contract as `setLastActiveCookie`: a new `lastActive` ends the Auth0 reauth window.
    Cookies.remove(AUTH_COOKIES.AUTH0_REAUTH, { path: '/' });
    Cookies.set(AUTH_COOKIES.TOKEN_EXPIRY, expiryTimestamp.toString(), {});
}

export async function loginExToken({ exchangeToken, user }: LoginExToken) {
    if (!user && exchangeToken) {
        const res = await consumeExchangeToken(exchangeToken);

        if (res && 'accessToken' in res) {
            setAuthCookies(res);

            return res;
        }

        return null;
    }

    return null;
}
